// VERSION 2.5

// ENHANCED VERSION - Detect typing inside HelloRep chatbot

(function () {
  ("use strict");

  let zendeskShown = false;
  let mutationObserver = null;
  let pageLoadTime = Date.now();
  const PAGE_LOAD_GRACE_PERIOD = 3000; // 3 seconds grace period

  function log(...args) {
    console.log("[HelloRep-Zendesk Integration]", ...args);
  }

  // Hide Zendesk on page load - FORCE HIDE
  function hideZendeskOnLoad() {
    log("💀 Force hiding Zendesk on page load...");

    // Immediate hide
    if (window.zE) {
      try {
        window.zE("messenger", "hide");
        log("✅ Zendesk hidden immediately");
      } catch (e) {
        log("❌ Error hiding Zendesk:", e.message);
      }
    }

    // Force hide multiple times to ensure it stays hidden
    // BUT ONLY IF zendeskShown is false (user hasn't manually opened it)
    setTimeout(() => {
      if (window.zE && !zendeskShown) {
        try {
          window.zE("messenger", "hide");
          log("✅ Force hide #1 (1 second)");
        } catch (e) {
          log("⚠️ Force hide #1 failed:", e.message);
        }
      }
    }, 1000);

    setTimeout(() => {
      if (window.zE && !zendeskShown) {
        try {
          window.zE("messenger", "hide");
          log("✅ Force hide #2 (3 seconds)");
        } catch (e) {
          log("⚠️ Force hide #2 failed:", e.message);
        }
      }
    }, 3000);

    setTimeout(() => {
      if (window.zE && !zendeskShown) {
        try {
          window.zE("messenger", "hide");
          log("✅ Force hide #3 (5 seconds)");
        } catch (e) {
          log("⚠️ Force hide #3 failed:", e.message);
        }
      }
    }, 5000);

    // Also try to close if it's open
    // BUT ONLY IF zendeskShown is false (user hasn't manually opened it)
    setTimeout(() => {
      if (window.zE && !zendeskShown) {
        try {
          window.zE("messenger", "close");
          log("✅ Force close (2 seconds)");
        } catch (e) {
          log("⚠️ Force close failed:", e.message);
        }
      }
    }, 2000);
  }

  // Show Zendesk (button only mode)
  function showZendesk() {
    if (zendeskShown) return;

    log("🎯 Zendesk button clicked!");

    if (window.zE) {
      try {
        window.zE("messenger", "show");
        setTimeout(() => {
          window.zE("messenger", "open");
          log("✅ Zendesk messenger opened");
        }, 100);
        zendeskShown = true;
        document.body.classList.add("zendesk-messenger-active");
        
        // Update button text to show "Close Live Support"
        const triggerButton = document.getElementById("rbs-zendesk-trigger-button");
        if (triggerButton) {
          const openedSpan = triggerButton.querySelector(".zendesk-status-opened");
          const closedSpan = triggerButton.querySelector(".zendesk-status-closed");
          
          if (openedSpan && closedSpan) {
            openedSpan.classList.remove("show");
            closedSpan.classList.add("show");
          }
        }
      } catch (e) {
        log("❌ Error showing/opening Zendesk:", e.message);
      }
    } else {
      log("❌ window.zE not available");
    }
  }

  // Continuous Zendesk monitoring to prevent auto-opening
  function setupContinuousZendeskMonitoring() {
    log("🔄 Setting up continuous Zendesk monitoring...");
    
    // Check every 5 seconds if Zendesk is trying to open and force it closed
    // BUT ONLY IF zendeskShown is false (user hasn't manually opened it)
    setInterval(() => {
      if (window.zE && !zendeskShown) {
        try {
          window.zE("messenger", "hide");
        } catch (e) {
          // Silent fail to avoid console spam
        }
      }
    }, 5000);
  }

  // Monitor DOM mutations for dynamically added elements
  function setupMutationObserver() {
    log("👁️ Setting up mutation observer...");

    mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Log new elements for debugging
            log("🆕 New element added:", node.tagName, node.id, node.className);
          }
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }



  // Setup Zendesk trigger button
  function setupZendeskTrigger() {
    const triggerButton = document.getElementById("rbs-zendesk-trigger-button");

    if (triggerButton) {
      log("✅ Found Zendesk trigger button");

      triggerButton.addEventListener("click", function (event) {
        event.preventDefault();
        log("🖱️ Zendesk trigger clicked");

        // Toggle the "show" class between the spans
        const openedSpan = triggerButton.querySelector(".zendesk-status-opened");
        const closedSpan = triggerButton.querySelector(".zendesk-status-closed");
        
        if (openedSpan && closedSpan) {
          if (zendeskShown) {
            // Hide Zendesk if it's currently shown
            if (window.zE) {
              try {
                window.zE("messenger", "hide");
                log("✅ Zendesk hidden via button");
                zendeskShown = false;
                document.body.classList.remove("zendesk-messenger-active");
                
                // Update button text - show "Open Live Support"
                openedSpan.classList.add("show");
                closedSpan.classList.remove("show");
              } catch (e) {
                log("❌ Error hiding Zendesk:", e.message);
              }
            }
          } else {
            // Show Zendesk if it's currently hidden
            showZendesk();
            
            // Update button text - show "Close Live Support"
            openedSpan.classList.remove("show");
            closedSpan.classList.add("show");
          }
        }
      });
    } else {
      log("❌ Zendesk trigger button not found");
    }
  }

  // Initialize everything
  function init() {
    log("🚀 Initializing HelloRep + Zendesk integration...");

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
      return;
    }

    // Override Zendesk methods to prevent unauthorized opening
    if (window.zE) {
      const originalShow = window.zE;
      window.zE = function(command, action, ...args) {
        // Only allow show/open if we explicitly want it
        if (command === "messenger" && (action === "show" || action === "open")) {
          if (!zendeskShown) {
            log("🚫 Blocking unauthorized Zendesk show/open");
            return;
          }
        }
        return originalShow.apply(this, arguments);
      };
      log("✅ Zendesk methods overridden for security");
    }

    // Hide Zendesk initially
    hideZendeskOnLoad();

    // Setup Zendesk trigger
    setupZendeskTrigger();

    // Setup monitoring methods (text triggers disabled)
    setupMutationObserver();
    setupContinuousZendeskMonitoring();
    setupHelloRepClickMonitoring();



    log("✅ Integration ready - ONLY manual button triggers allowed");
  }

  // Public API for testing
  window.HelloRepZendeskIntegration = {
    showZendesk: () => {
      log("🧪 Manual show Zendesk");
      showZendesk();
    },
    hideZendesk: () => {
      log("🧪 Manual hide Zendesk");
      if (window.zE) {
        try {
          window.zE("messenger", "hide");
          zendeskShown = false;
          document.body.classList.remove("zendesk-messenger-active");
          log("✅ Zendesk hidden");
        } catch (e) {
          log("❌ Error hiding Zendesk:", e.message);
        }
      }
    },
    isZendeskShown: () => zendeskShown,
    reset: () => {
      zendeskShown = false;
      log("🔄 Reset - Zendesk can be shown again");
    },
  };

  // Monitor HelloRep container clicks and add class to body
  function setupHelloRepClickMonitoring() {
    log("👁️ Setting up HelloRep click monitoring...");

    // Monitor for HelloRep container
    const helloRepObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.id === "repWebClientContainer") {
            log("🎯 HelloRep container detected, setting up click monitoring");
            setupHelloRepClickListeners(node);
          }
        });
      });
    });

    helloRepObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Also check if HelloRep container already exists
    const existingHelloRep = document.getElementById('repWebClientContainer');
    if (existingHelloRep) {
      log("🎯 HelloRep container already exists, setting up click monitoring");
      setupHelloRepClickListeners(existingHelloRep);
    }
  }

  // Setup click listeners for HelloRep container
  function setupHelloRepClickListeners(helloRepContainer) {
    // Monitor clicks on the container itself
    helloRepContainer.addEventListener('click', function(event) {
      log("🖱️ HelloRep container clicked");
      document.body.classList.add("hellorep-active");
    }, true); // Use capture to catch events from shadow DOM

    // Monitor clicks inside shadow DOM
    if (helloRepContainer.shadowRoot) {
      helloRepContainer.shadowRoot.addEventListener('click', function(event) {
        log("🖱️ HelloRep shadow DOM clicked");
        document.body.classList.add("hellorep-active");
      }, true);
    }

    // Monitor for shadow DOM creation and setup listeners
    const shadowObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Shadow DOM was created, setup click listener
          if (helloRepContainer.shadowRoot) {
            helloRepContainer.shadowRoot.addEventListener('click', function(event) {
              log("🖱️ HelloRep shadow DOM clicked (dynamic)");
              document.body.classList.add("hellorep-active");
            }, true);
          }
        }
      });
    });

    shadowObserver.observe(helloRepContainer, {
      childList: true,
      subtree: true,
    });
  }

  // Start initialization
  init();
})();